import { NewsTag, TagChoice } from './types';

/** An instrument is identified by its PM asset ID, never by its current label. */
export const tagLabel = (tag: TagChoice) =>
  tag.instrument_id != null
    ? tag.canonical_text || tag.ric || `Asset ${tag.instrument_id}`
    : tag.text;

export const tagChoiceKey = (tag: TagChoice) =>
  tag.instrument_id != null
    ? `instrument:${tag.instrument_id}`
    : `text:${tag.text.trim().toLocaleLowerCase()}`;

export const sameTag = (left: TagChoice, right: TagChoice) => {
  if (left.instrument_id != null || right.instrument_id != null)
    return (
      left.instrument_id != null && left.instrument_id === right.instrument_id
    );
  if (left.id != null && right.id != null) return left.id === right.id;
  return tagChoiceKey(left) === tagChoiceKey(right);
};

export const canonicalChoice = (tag: NewsTag): NewsTag => ({
  ...tag,
  id: tag.canonical_tag_id ?? tag.id,
  text: tagLabel(tag),
});

export type NewsTagGroup = {
  key: string;
  label: string;
  tag: NewsTag;
  tagIds: number[];
};

/** Project aliases into one chip while retaining every physical membership. */
export const groupNewsTags = (tags: NewsTag[]): NewsTagGroup[] => {
  const groups = new Map<string, NewsTagGroup>();
  for (const tag of tags) {
    const key = tag.instrument_id != null ? tagChoiceKey(tag) : `tag:${tag.id}`;
    const group = groups.get(key);
    if (group) {
      if (!group.tagIds.includes(tag.id)) group.tagIds.push(tag.id);
    } else {
      groups.set(key, { key, label: tagLabel(tag), tag, tagIds: [tag.id] });
    }
  }
  return Array.from(groups.values()).map(group => ({
    ...group,
    tagIds: [...group.tagIds].sort((left, right) => left - right),
  }));
};
